import apiClient, { getCsrfCookie } from './client';

export type IntegrationStatus = 'not_configured' | 'configured' | 'test_passed';

export interface SetupRequired {
  company: boolean;
  branding: boolean;
  tax: boolean;
}

/** #350 — per-wizard-step completion flags (finer than SetupRequired). */
export interface SetupSections {
  legal: boolean;
  address: boolean;
  contact: boolean;
  branding: boolean;
  tax: boolean;
}

export interface SetupIntegrations {
  stripe: IntegrationStatus;
  mollie: IntegrationStatus;
  email: IntegrationStatus;
  documenso: IntegrationStatus;
  factura_directa: IntegrationStatus;
  anthropic: IntegrationStatus;
}

export interface SetupStatus {
  setup_complete: boolean;
  required: SetupRequired;
  /** Optional for backward compatibility — present from the #350 backend on. */
  sections?: SetupSections;
  integrations: SetupIntegrations;
}

const SETUP_BASE = '/api/admin/setup';

export const setupApi = {
  async getStatus(): Promise<SetupStatus> {
    const response = await apiClient.get<{ data: SetupStatus }>(`${SETUP_BASE}/status`);
    return response.data.data;
  },

  async markComplete(): Promise<SetupStatus> {
    await getCsrfCookie();
    const response = await apiClient.post<{ data: SetupStatus }>(`${SETUP_BASE}/mark-complete`);
    return response.data.data;
  },
};
